// src/pages/AddKitchen/KitchenWelcome.js

import React from "react";
import { Box, Typography, Button } from "@mui/material";
import welcomeImg from "../../assets/images/image.png"; // add your image here

const KitchenWelcome = ({ onNext }) => {
  return (
    <Box
      sx={{
        textAlign: "center",
        p: { xs: 2, sm: 4, md: 6 },
        bgcolor: "#f9f9f9",
        borderRadius: 3,
        boxShadow: 1,
      }}
    >
      <img
        src={welcomeImg}
        alt="Welcome Kitchen"
        style={{
          width: "100%",
          maxHeight: 300,
          objectFit: "cover",
          borderRadius: "12px",
          marginBottom: "24px",
        }}
      />

      <Typography variant="h4" gutterBottom>
        Kitchen Income Starts Here!
      </Typography>

      <Typography variant="body1" sx={{ maxWidth: 600, mx: "auto", mb: 3 }}>
        Let's get your kitchen listed and ready to earn. We’ll guide you through
        each step—add your kitchen details, pricing, documents, and photos.
      </Typography>

      <Button
        variant="contained"
        size="large"
        onClick={onNext}
        sx={{ backgroundColor: "#2c3e50", mt: 2 }}
      >
        Get Started
      </Button>
    </Box>
  );
};

export default KitchenWelcome;
